import React, { CSSProperties } from 'react';

interface ITermsAndConditionsProps {
    url: string;
    classes?: string;
    styles?: CSSProperties;
}

const TermsAndConditions = ({ url, classes, styles }: ITermsAndConditionsProps) => {
    return (
        <a
            href={ url }
            className={ `inapp-hidden no-underline hover:underline text-xs ${ classes ?? '' }` }
            style={{
                ...styles || {},
                color: '#595c5f'
            }}>
            Terms apply
        </a>
    )
};

export default TermsAndConditions;